<template>
  <div>
    <div class="air__utils__heading">
      <div class="d-flex justify-content-between">
        <h5>{{ settings.module }}</h5>
      </div>
    </div>
    <b-card>
      <template v-if="loading">
        <div class="d-flex justify-content-center bd-highlight mb-3">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </template>
      <template v-else>
        <h4 class="mb-4">
          <strong>Dados Pessoais</strong>
        </h4>
        <Form :user="user" class="mt-2"></Form>
      </template>
    </b-card>

    <b-card>
      <div class="air__utils__heading">
        <div class="d-flex justify-content-between">
          <h5>{{ settings.subModuleTitle }}</h5>
          <b-button
            title="Adicionar"
            size="sm"
            @click.prevent="addSubordinate()"
            class="mr-1 ml-2"
          >
            <i class="fe fe-plus"></i>
          </b-button>
        </div>
      </div>

      <Subordinates class="mt-4" :settings="settings" />
    </b-card>
  </div>
</template>

<script>
import Form from "@/components/operations/Form";
import { UsuarioResource } from "@/resources/Usuario.resource.js";
import Subordinates from "@/components/operations/Subordinates";

export default {
  components: {
    Form,
    Subordinates
  },
  // props: {
  //   settings: {
  //     type: Object,
  //     default: () => {}
  //   }
  // },
  data() {
    return {
      loading: true,
      user: {},
      settings: null
    };
  },
  created() {
    this.getUserInfo();
  },

  methods: {
    addSubordinate() {
      this.$router.push({
        name: "operacional-register",
        params: {
          settings: {
            ...this.settings,
            parent: this.$route.params.id || null
          }
        }
      });
    },
    async getUserInfo() {
      const v = this;
      await UsuarioResource.getUserWithBankAccount(null, {
        id: this.$route.params.id
      })
        // await this.$api
        //   .get(`v1/user/${this.$route.params.id}/withbankaccount`)
        .then(result => {
          this.loading = false;
          if (!result.data.payload) {
            this.$router.push({ path: "/404" });
          }
          v.user = result.data.payload;
        })
        .catch(e => {
          // Surpress
        });
    }
  }
};
</script>
